import {createMultiPathSVG, createStrokeSVG} from './TEMPLATE'

// tabler: user-check
export const PersonCheck_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M6 21v-2a4 4 0 0 1 4 -4h4',
    'M15 19l2 2l4 -4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: users
export const PersonGroup_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0',
    'M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2',
    'M16 3.13a4 4 0 0 1 0 7.75',
    'M21 21v-2a4 4 0 0 0 -3 -3.85',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: user (fill weight)
export const PersonPlus_Filled_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z',
    'M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z',
  ],
  viewBox: '0 0 24 24',
})

// tabler: user-plus
export const PersonPlus_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M16 19h6',
    'M19 16v6',
    'M6 21v-2a4 4 0 0 1 4 -4h4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: user-plus
export const PersonPlus_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M16 19h6',
    'M19 16v6',
    'M6 21v-2a4 4 0 0 1 4 -4h4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: user-x
export const PersonX_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M6 21v-2a4 4 0 0 1 4 -4h3.5',
    'M22 22l-5 -5',
    'M17 22l5 -5',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: user-x
export const PersonX_Stroke2_Corner0_Rounded_Large = createStrokeSVG({
  paths: [
    'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M6 21v-2a4 4 0 0 1 4 -4h3.5',
    'M22 22l-5 -5',
    'M17 22l5 -5',
  ],
  viewBox: '2 2 20 20',
  strokeWidth: 2,
})

// tabler: user (fill weight)
export const Person_Filled_Corner2_Rounded = createMultiPathSVG({
  paths: [
    'M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z',
    'M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z',
  ],
  viewBox: '0 0 24 24',
})

// tabler: user
export const Person_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: user
export const Person_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
